import { getSystemAlertList } from '../../api/systemAlertApi';
import { SystemAlertData } from '../../dto/EntityRepository';
import { SystemAlertListResponse } from '../../dto/ResDtoRepository';
import { useApiWrapper } from './apiWrapper';
import { useSystemAlertStore } from '../../store/systemAlertStore';

interface UseSystemAlertResult {
  systemAlertList: SystemAlertData[];
  getSystemAlertList: () => Promise<void>;
}

export const useSystemAlert = (): UseSystemAlertResult => {
  const { systemAlertList, setSystemAlertList } = useSystemAlertStore();
  const withApiHandler = useApiWrapper();

  const handleGetSystemAlertListSuccess = (response: SystemAlertListResponse) => {
    const systemAlertListData = response.data;
    setSystemAlertList(systemAlertListData);
  };

  const handleSystemAlertRequest = async (
    action: 'get',
  ) => {
    const apiFunction = async () => {
      switch (action) {
        case 'get':
        default:
          return handleGetSystemAlertListSuccess(await getSystemAlertList());
      }
    };

    await withApiHandler(apiFunction, [action]);
  };

  const getSystemAlertListHandler = () => handleSystemAlertRequest('get');

  return {
    systemAlertList,
    getSystemAlertList: getSystemAlertListHandler,
  };
}